var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-header heimage-box"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/logo.png"),"alt":"logo"}}),_vm._v(" "),_c('span',[_vm._v("종목분석")])])
}]

export { render, staticRenderFns }